export class AnchorLinkHandler {
    static init() {

        window.addEventListener('load', () => {

            const id = location.hash.slice(1)
            const element = document.getElementById(id)
            if (element) AnchorLinkHandler.scrollToElement(element);
        })

        document.querySelectorAll('a[href*="#"]').forEach(linkElement => new AnchorLinkHandler(linkElement))

    }

    static scrollToElement(target, onclick) {
        if(!onclick) {
            window.scrollTo({
                top: 0,
                behavior: 'instant'
            })
        }
        setTimeout(() => {
            let scrollPosition = target ? target.getBoundingClientRect().top  + window.scrollY : 0
            if (scrollPosition > 0) {
                const contentContainer = target.closest('.content-container')
                const navigation = document.querySelector('.nav')

                if (contentContainer) {
                    scrollPosition -= parseInt(window.getComputedStyle(contentContainer).paddingTop)
                }

                if (navigation) {
                    scrollPosition -= parseInt(window.getComputedStyle(navigation).height)
                }
            }
            window.scrollTo(0, scrollPosition)

        }, onclick ? 0 : 1000)
    }

    constructor(element) {
        this.el = element
        this.targetId = element.href.split('#')[1];
        this.target = document.getElementById(this.targetId)
        if(!element.getAttribute('href').match(/^https?:\/\//)) {
            this.el.addEventListener('click', (e) => this.onClick(e))
        }
    }

    onClick(e) {
        e.preventDefault();
        history.pushState(null, null, '#' + this.targetId)
        AnchorLinkHandler.scrollToElement(this.target, true)

    }
}
